import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { PromoProductFamily } from 'src/app/assabil-sales/models/entities/promo-product-family.entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { PromoProductFamilyProduct } from 'src/app/assabil-sales/models/entities/promo-product-family-partner.entity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { ProductLovComponent } from 'src/app/assabil-admin/components/master-data/product/product-lov/product-lov.component';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'promo-product-family-widget',
    templateUrl: './promo-product-family-widget.component.html',
    styleUrls: ['./promo-product-family-widget.component.scss']
})

export class PromoProductFamilyWidgetComponent extends BaseWidget {

  promoProductFamily            : PromoProductFamily = new PromoProductFamily();

  productColumns = [
    { prop: 'product.productCode',  name: 'Code',     readOnly : true  },
    { prop: 'product.name',         name: 'Nom',      readOnly : true  },
    { prop: 'sequence',             name: 'Sequence', readOnly : false },
    { prop: 'promoRate',            name: 'Taux',     readOnly : false },
  ] 

  constructor(
      protected promoService      : PromoService,
      protected toastr            : ToastrService,
      protected dialog            : MatDialog,
      protected leanUtilsService  : LeanUtilsService) {
      super(toastr, leanUtilsService);
  //    this.productCategoryTypeContainer = new EntityContainer(ProductCategoryType);
  }

  //------------------------------------------------------
  setEntity(promoProductFamily: PromoProductFamily) {
      this.promoProductFamily  = { ...promoProductFamily };
      this.promoProductFamily.promoProductFamilyProducts = [];
      if (promoProductFamily.promoProductFamilyProducts) {
        for (let promoProductFamilyProduct of promoProductFamily.promoProductFamilyProducts) {
          this.promoProductFamily.promoProductFamilyProducts.push({ ...promoProductFamilyProduct });
        }
      }
  }
  
  getEntity(){
    return this.promoProductFamily;
  }
  //------------------------------------------------------


  //------------------------------------------------------
  saveRow() : Promise<PromoProductFamily>{
    return this.promoService.promoProductFamilySave(this.promoProductFamily);
  }
  //------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
products : Product[];
new(){
  let dialogRef = this.dialog.open(ProductLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual : true, products  : this.products}});
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.products = result.products;
      if (result.selectedProducts) this.addProducts(result.selectedProducts);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------

  
//-----------------------------------------------------------------------------------------------------------------------------
addProducts(products : Product[]){
  for (let product of products){
      let nr = new PromoProductFamilyProduct();
      nr.inserted = true;
      nr.edit      = true;
      nr.promoProductFamilyCode = this.promoProductFamily.promoProductFamilyCode;
      nr.product  = new Product();
      nr.product.productCode  = product.productCode;
      nr.product.name         = product.name;
      this.promoProductFamily.promoProductFamilyProducts.push(nr);
  }
  this.promoProductFamily.promoProductFamilyProducts = [...this.promoProductFamily.promoProductFamilyProducts];  
}
//-----------------------------------------------------------------------------------------------------------------------------


}